/* src/pages/pdf-landscape/page-pdf-landscape.component.scss */
html {
  --vwui-app-main--padding-x: 0;
  --vwui-card--height: 14mm;
  --chart-signal-matrix-height: 52mm;
  --chart-signal-matrix-max-height: 52mm;
  --chart-signal-matrix-height-large: 75mm;
  --chart-signal-matrix-max-height-large: 75mm;
  font-size: 3.5mm;
}
.prevent-pagebreak-inside {
  page-break-inside: avoid;
}
.pdf-page {
  display: table;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  height: auto;
  min-height: auto;
  max-height: none;
  border-spacing: 0;
}
.pdf-page__header--hidden,
.pdf-page__footer--hidden {
  display: none;
}
.pdf-page__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 10mm 10mm 10mm;
}
@media print {
  .pdf-page__footer {
    position: fixed;
    padding-bottom: 0;
  }
}
.pdf-page__header-body,
.pdf-page__footer-body {
  vertical-align: top;
  text-align: left;
  font-weight: normal;
}
.pdf-page__content-body {
  word-break: break-word;
}
.pdf-page__project-image {
  position: relative;
  z-index: 1;
  display: block;
  width: calc(100% + 10mm);
  height: 140mm;
  margin: 10mm 0 10mm -10mm;
  background: var(--vwui-color-neutral-4) center no-repeat url(/assets/empty-image.svg);
  border-radius: 0 var(--vwui--radius--md) var(--vwui--radius--md) 0;
  overflow: hidden;
}
.pdf-page__project-image img {
  position: relative;
  z-index: 1;
  display: block;
  width: inherit;
  height: inherit;
  object-fit: cover;
}
.pdf-page__project-intro {
  position: absolute;
  z-index: 2;
  bottom: 10mm;
  left: 0;
  right: 10mm;
  padding: 8mm 10mm;
  background: rgba(0, 140, 188, 0.9);
  border-radius: 0 var(--vwui--radius--md) var(--vwui--radius--md) 0;
  color: #fff;
}
.pdf-page__project-title {
  display: block;
  margin: 0 0 0.5rem 0;
  padding: 0;
  font-size: 2rem;
  font-weight: 500;
  line-height: 1;
}
.pdf-page__project-subtitle,
.pdf-page__project-description {
  font-weight: 500;
}
.pdf-page__project-note {
  position: relative;
  display: block;
  padding: 1.5mm 0 0 4.5mm;
}
.pdf-page__project-note--bottom {
  margin-top: -1.5mm;
}
.pdf-page__project-note vwui-icon {
  --vwui-icon--size: 3mm;
  position: absolute;
  top: 1.9mm;
  left: 0;
  display: inline-block;
  vertical-align: top;
}
.pdf-page__project-table-subtitle {
  font-size: xx-small;
  font-weight: 500;
  display: inline;
  margin-left: var(--vwui-size-spacing-lg);
}
.pdf-page__risks-opportunities-table {
  --padding-side: 2mm !important;
  --vwui-size-spacing-lg: 2mm;
  width: 100%;
  min-width: 100%;
  max-width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 2mm;
  line-height: 2.2mm;
}
.pdf-page__risks-opportunities-table thead th {
  vertical-align: top;
  text-align: center;
  font-weight: 500;
  border: 1px solid var(--vwui--color--border-light);
  padding: 2mm;
}
.pdf-page__risks-opportunities-table tbody tr {
  page-break-inside: avoid;
}
.pdf-page__risks-opportunities-table tbody td {
  vertical-align: top;
  text-align: left;
  border: 1px solid var(--vwui--color--border-light);
  padding: 2mm;
}
.pdf-page__risks-opportunities-table tfoot {
  visibility: hidden;
  opacity: 0;
  line-height: 10mm;
}
.pdf-page__risks-opportunities-table thead th.vertical-label,
.pdf-page__risks-opportunities-table thead td.vertical-label,
.pdf-page__risks-opportunities-table tbody th.vertical-label,
.pdf-page__risks-opportunities-table tbody td.vertical-label {
  vertical-align: bottom;
  height: 22mm;
}
.pdf-page__risks-opportunities-table thead th.center-number,
.pdf-page__risks-opportunities-table thead td.center-number,
.pdf-page__risks-opportunities-table tbody th.center-number,
.pdf-page__risks-opportunities-table tbody td.center-number {
  text-align: center;
  padding: 2mm 0;
  white-space: nowrap;
}
.pdf-page__risks-opportunities-table thead th.col-checkbox,
.pdf-page__risks-opportunities-table thead td.col-checkbox,
.pdf-page__risks-opportunities-table tbody th.col-checkbox,
.pdf-page__risks-opportunities-table tbody td.col-checkbox {
  background-color: var(--vwui-color-neutral-4);
  width: 2rem;
  padding: 0.4rem;
}
.pdf-page__risks-opportunities-table thead td.col-checkbox,
.pdf-page__risks-opportunities-table tbody td.col-checkbox {
  vertical-align: top;
}
.pdf-page__risks-opportunities-table thead th.col-checkbox,
.pdf-page__risks-opportunities-table tbody th.col-checkbox {
  vertical-align: bottom;
}
.pdf-page__risks-opportunities-table-col-highlight {
  background-color: var(--vwui-color-neutral-4);
}
.pdf-page__risks-opportunities-table-vertical-label {
  display: inline-block;
  vertical-align: bottom;
  width: 18mm;
  white-space: nowrap;
  transform: rotate(270deg) translateX(-2.2mm);
  transform-origin: 0 0;
  text-align: left;
}
.pdf-page__risks-opportunities-table-title {
  font-weight: 500;
}
.pdf-page__risks-opportunities-table-text {
  font-weight: normal;
  margin: 0.5mm 0;
}
.pdf-page__risks-opportunities-table-text vwui-icon {
  --vwui-icon--size: 2mm;
  display: inline-block;
  vertical-align: top;
  margin: -0.1mm 1mm -0.21mm 0;
}
.pdf-page__risks-opportunities-table-label {
  position: relative;
  padding: 0 0 0 9mm;
  margin: 1mm 0 0 0;
}
.pdf-page__risks-opportunities-table-label--wide {
  padding-left: 12mm;
}
.pdf-page__risks-opportunities-table-label[title]::before {
  display: block;
  white-space: nowrap;
  font-weight: 500;
  content: attr(title);
  position: absolute;
  top: 0;
  left: 0;
}
.pdf-page__risks-opportunities-table-col-number {
  width: 1.5%;
}
.pdf-page__risks-opportunities-table-col-category {
  width: 11%;
}
.pdf-page__risks-opportunities-table-col-description {
  width: 25%;
}
.pdf-page__risks-opportunities-table-col-status {
  width: 5.5%;
}
.pdf-page__risks-opportunities-table-col-remarks {
  width: 22.5%;
}
.pdf-page__risks-opportunities-quantification-grid {
  position: relative;
  z-index: 1;
  transform: scale(0.5);
  transform-origin: 0 0;
  transform-style: preserve-3d;
  height: 320px;
  margin-bottom: -160px;
}
html.pdf-page-a3-landscape,
html.pdf-page-a3-landscape body {
  width: 100%;
  height: auto;
  background: var(--vwui-color-neutral-4);
  --vwui-shadow-base: none;
}
app-pdf-page {
  padding: 10mm;
  margin: 60px auto;
  background: #FFFFFF;
  width: 420mm;
  min-height: 297mm;
  box-shadow: 10px 10px 90px 0 rgba(0, 0, 0, 0.1);
}
* {
  margin: 0;
  padding: 0;
  border: 0;
  box-sizing: border-box;
  background: transparent;
  transition: none !important;
  animation: none !important;
}
#pageReadyForPdfGeneration {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
}
@media print {
  * {
    -webkit-print-color-adjust: exact;
  }
  html.pdf-page-a3-landscape,
  html.pdf-page-a3-landscape body {
    width: 420mm !important;
    min-width: 420mm !important;
    max-width: 420mm !important;
    height: auto;
    overflow: hidden;
    zoom: 1;
    background: #FFFFFF;
  }
  app-pdf-page {
    padding: 0 10mm;
    margin: 0;
    min-height: 0;
    box-shadow: none;
  }
}
@page {
  margin: 10mm 0;
  padding: 0;
  size: 420mm 297mm;
}
app-page-pdf {
  display: block;
}
/*# sourceMappingURL=page-pdf-landscape.component-NQK7A5W4.css.map */
